
import { Button } from "./ui/button";
import { MessageSquare } from "lucide-react";
import { useSidebar } from "./ui/sidebar";
import { useIsMobile } from "../hooks/use-mobile";
import { Search } from "./Search";
import { Link } from "react-router-dom";
import { MobileMenu } from "./MobileMenu";
import React from "react";

export function TopBar() {
  const { toggleSidebar } = useSidebar();
  const isMobile = useIsMobile();

  return (
    <header className="sticky top-0 z-50 w-full border-b bg-background">
      <div className="flex items-center h-14 px-4 w-full mx-auto">
        {isMobile ? (
          <>
            <Link to="/" className="flex items-center gap-2 mr-4">
              <MessageSquare className="h-6 w-6" />
            </Link>
            <div className="flex-1">
              <Search />
            </div>
            <MobileMenu />
          </>
        ) : (
          <div className="flex-1 mx-auto">
            <Search />
          </div>
        )}
      </div>
    </header>
  );
}